<template>
    <v-icon
        class="btn-edit"
        :style="{
            'font-size': size+'px'
        }"
        @click="$emit('click')"
    >mdi-pencil</v-icon>
</template>

<script>
export default {
    props: {
        size: {type: Number, default: 16}
    }
}
</script>

<style lang="scss">
@import './src/assets/scss/vars';

.btn-edit {
    cursor: pointer;

    &:hover {
         color: $colorPrimary;
     }
}
</style>